import { gql } from '@apollo/client'

const DELETE_RECURRING_TASKS = gql`
  mutation deleteRecurringTasks(
    $checklistItemId: Int!
    $checklistItemGroupId: Int!
    $option: DeleteRecurringTasksOption!
    $nonprofitOrgId: Int!
  ) {
    deleteRecurringTasks(
      checklistItemId: $checklistItemId
      checklistItemGroupId: $checklistItemGroupId
      option: $option
      nonprofitOrgId: $nonprofitOrgId
    ) {
      id
    }
  }
`

export default DELETE_RECURRING_TASKS
